import { useMemo } from "react";
import { objectFilterUndefined } from "../../../utils/js/missing-js-parts";
import { LoadingStateOps } from "../../../domain/data-layer/loading-state";
import { useResourceRelatedInfo } from "../../../hooks/use-resource-related-info";
import { either as E } from "fp-ts";
import { query } from "./query-storefront";
import { useStale } from "../../../hooks";
import { ActivatedFacets } from "../../../components/_shared-components/generic-listing-page/types";
import { PlpRootLevelProps } from "../levels/0-root-level";
import { getActivatedFacets } from "./getActivatedFacets";

const stringId = <A>(_: A) => JSON.stringify(_);
const Id = <A>(_: A) => _;

export function useStorefrontData(props: Pick<PlpRootLevelProps, "subpage" | "page" | "segment">) {
  const activatedFacets: ActivatedFacets = getActivatedFacets(props.subpage);

  const facetsQuery = useMemo(() => objectFilterUndefined(activatedFacets), [activatedFacets]);

  const storefrontQueryObject = LoadingStateOps.asLoaded({
    locale: { code: props.page.localeCode },
    categoryKey: props.page.categoryKey,
    segmentKey: props.segment.key,
    facetsQuery: facetsQuery,
    subpage: props.subpage,
  });

  const storefrontResponse = useResourceRelatedInfo(
    storefrontQueryObject,
    Id,
    ({ locale, categoryKey, segmentKey, facetsQuery }) =>
      E.right({
        data: {
          localeCode: locale.code,
          categoryKey: categoryKey,
          segmentKey: segmentKey,
        },
        facetsQuery: facetsQuery,
      }),
    ({ data, facetsQuery }) => query(data, facetsQuery),
  );

  const storefrontResponseWithStaleness = useStale(storefrontResponse, 1500, i => i.__tag === "loaded");
  // const storefrontResponseWithStaleness = storefrontResponse;

  return [facetsQuery, storefrontResponse, storefrontResponseWithStaleness] as const;
}
